import React from 'react';

import { getMainListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import {
  isCitySearch,
  isCountrySearch,
  isStreetSearch,
} from '@kamernet/modules/Search/utilities';
import { ListingsSearchContext } from '@kamernet/views/ListingsSearch/ListingsSearchContext';

import { ContentCity } from './ContentCity';
import { ContentCountry } from './ContentCountry';
import { ContentStreet } from './ContentStreet';

export const Content = () => {
  const { allFilters } = ListingsSearchContext.useContext();

  const mainSearchCategory = getMainListingsSearchCategory(
    allFilters.searchCategories,
  );

  if (isCountrySearch(allFilters)) {
    return <ContentCountry mainSearchCategory={mainSearchCategory} />;
  }

  if (isCitySearch(allFilters)) {
    return (
      <ContentCity
        cityName={allFilters.cityName}
        citySlug={allFilters.citySlug}
        mainSearchCategory={mainSearchCategory}
      />
    );
  }

  if (isStreetSearch(allFilters)) {
    return (
      <ContentStreet
        streetName={allFilters.streetName}
        cityName={allFilters.cityName}
        mainSearchCategory={mainSearchCategory}
      />
    );
  }

  return null;
};
